// extracted by mini-css-extract-plugin
export default {"roundIcon":"MapRider_roundIcon__ZLK8q"};